import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Prompt from './pages/Prompt';
import Search from './pages/Search';
import Raw from './pages/Raw';
import AudienceVector from './pages/AudienceVector';
import SharedLayout from './pages/SharedLayout';
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<SharedLayout />}>
          <Route index element={<Search />} />
          <Route path='prompt' element={<Prompt />} />
          <Route path='vector' element={<AudienceVector />} />
          <Route path='raw' element={<Raw />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
